/**
 * クエリパラメータコントロール用middleware
 */
import { selectorModeValue, searchTypeValue } from '@/features/parking/types';
import { useParkingState } from '@/composables/store/useParkingStore';
import { PARKING_TYPE } from '~/features/monthly/constants/parkingType';
import { resolveDeepLinkPath } from '@/utils/resolveDeepLinkPath';

export default defineNuxtRouteMiddleware((to, from) => {
  // DeepLink / AppLinkのクエリパラメータを変換してルーティング
  const deepLinkRoute = resolveDeepLinkPath(to.query);
  if (deepLinkRoute) {
    return navigateTo({ path: deepLinkRoute.path, query: deepLinkRoute.query });
  }

  // 以下はトップ専用の処理
  if (to.path !== '/') return;

  const { storedParkingsOnLists } = useParkingState();
  const { isNatural } = useValidation();

  // ブラウザバックした時、検索条件が前と同じならpageパラメータを復元
  if (
    to.query.selectorMode === 'parking' &&
    to.query.searchType === storedParkingsOnLists.value.searchType &&
    to.query.page !== String(storedParkingsOnLists.value.page) &&
    to.query.parkingType === storedParkingsOnLists.value.parkingType
  ) {
    // キーワード検索の場合は復元しない
    if (to.query.keywords && from.query.keywords) return;

    return navigateTo({
      path: '/',
      query: {
        ...to.query,
        selectorMode: 'parking',
        searchType: storedParkingsOnLists.value.searchType,
        page: storedParkingsOnLists.value.page,
        parkingType: storedParkingsOnLists.value.parkingType,
      },
    });
  }

  // パラメータが不正な場合は位置検索のHOME画面にリダイレクト
  if (
    !selectorModeValue.some((v) => v === to.query.selectorMode) ||
    (to.query.searchType &&
      !searchTypeValue.some((v) => v === to.query.searchType)) ||
    (to.query.page && !isNatural(String(to.query.page)))
  ) {
    return navigateTo({
      path: '/',
      query: {
        ...to.query,
        selectorMode: 'none',
        searchType: 'currentPlace',
        page: 1,
        parkingType: PARKING_TYPE.NORMAL,
      },
    });
  }
});
